import { baseUrl } from "../../../boot/index";
import axios from "axios";


export const addTaskMaster = async (formData) => {
    const token = localStorage.getItem("authToken")
    console.log('<<<<<<token',token)
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/create-taskmaster`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response; 
    } catch (error) {
      console.log({ error })
      throw error
    }
  }
  

  export const updateTaskMaster = async (id, data) => {
    console.log({'dataaaaaaaaaaaaaaaaaaaaa': data,id })
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.put(`${baseUrl}cleaningappfunctions/crm/app/v1/update-taskmaster/${id}`, data, {
        headers: {
          "auth-token": token,
        }
      })
      return response;
    } catch (error) {
      throw error
    }
  }
  // delete taskMaster
  export const deleteTaskMaster= async (ROWID) => {
    // console.log({'<<<<<<<<<<<<<<<<<<<<<<<<<ROWID>>>>>>>>>>>>>>':ROWID })
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.delete(`${baseUrl}cleaningappfunctions/crm/app/v1/delete-taskmaster/${ROWID}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log("Error is - ", error)
      throw error
    }
  }




export const getRelatedListTask = (ROWID) => async (dispatch) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}cleaningappfunctions/crm/app/v1/get-related-list-task/${ROWID}`,
      {}, // Body if needed
      {
        headers: {
          "auth-token": token,
        },
      }
    );

    // console.log("getRelatedListTask Response:", response);

    // Dispatch an action with the fetched data
    dispatch({
      type: "FETCH_RELATED_TASKS_SUCCESS",
      payload: response.data,
    });

    return response; // Optional: Allow component to handle response if needed
  } catch (error) {
    console.error("Error in getRelatedListTask:", error);
    
    // Dispatch an error action if needed
    dispatch({
      type: "FETCH_RELATED_TASKS_ERROR",
      payload: error.message,
    });

    throw error;
  }
};

export const getRelatedListTaskDeals = (ROWID) => async (dispatch) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}cleaningappfunctions/crm/app/v1/get-related-list-task-deals/${ROWID}`, {},
      {
        headers: {
          "auth-token": token,
        },
      }
    );
    dispatch({
      type: "FETCH_RELATED_TASKS_SUCCESS",
      payload: response.data,
    });
    return response;
  } catch (error) {
    console.error("Error in getRelatedListTask:", error);
    dispatch({
      type: "FETCH_RELATED_TASKS_ERROR",
      payload: error.message,
    });
    throw error;
  }
};


export const getRelatedListTaskClients = (ROWID) => async (dispatch) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}cleaningappfunctions/crm/app/v1/get-related-list-task-clients/${ROWID}`, {},
      {
        headers: {
          "auth-token": token,
        },
      }
    );
    dispatch({
      type: "FETCH_RELATED_TASKS_SUCCESS",
      payload: response.data,
    });
    return response;
  } catch (error) {
    console.error("Error in getRelatedListTask:", error);
    dispatch({
      type: "FETCH_RELATED_TASKS_ERROR",
      payload: error.message,
    });
    throw error;
  }
};

export const getRelatedListTaskCompanies = (ROWID) => async (dispatch) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}cleaningappfunctions/crm/app/v1/get-related-list-task-companies/${ROWID}`, {},
      {
        headers: {
          "auth-token": token,
        },
      }
    );
    dispatch({
      type: "FETCH_RELATED_TASKS_SUCCESS",
      payload: response.data,
    });
    return response;
  } catch (error) {
    console.error("Error in getRelatedListTask:", error);
    dispatch({
      type: "FETCH_RELATED_TASKS_ERROR",
      payload: error.message,
    });
    throw error;
  }
};
export const getRelatedListTaskWalk = (ROWID) => async (dispatch) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}cleaningappfunctions/crm/app/v1/get-related-list-task-walk/${ROWID}`, {},
      {
        headers: {
          "auth-token": token,
        },
      }
    );
    dispatch({
      type: "FETCH_RELATED_TASKS_SUCCESS",
      payload: response.data,
    });
    return response;
  } catch (error) {
    console.error("Error in getRelatedListTask:", error);
    dispatch({
      type: "FETCH_RELATED_TASKS_ERROR",
      payload: error.message,
    });
    throw error;
  }
};



export const countTaskmaster = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/count-taskmaster`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    // console.log("fetchTotalCount",response)
    return response;
  } catch (error) {
    throw error
  }
}

  
  